import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ element }) => {
  const { loggedIn } = useAuth();

  // If not logged in, redirect to home
  return loggedIn ? element : <Navigate to="/" replace />;
};

export default ProtectedRoute;
